module.exports = __webpack_public_path__ + "static/media/selectedMarker.cfca03d7.png";